var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentStep === _vm.STEPS.SIGNUP_FORM_STEP)?_c('signup-form',{attrs:{"config":_vm.config},on:{"success":_vm.handleSuccess}}):(_vm.currentStep === _vm.STEPS.SUCCESS_FORM_STEP)?_c('success-step',{attrs:{"config":_vm.config,"email":_vm.email}}):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }